import styled from "styled-components";

const ModalWrapper = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
  box-sizing: border-box;
`

const ModalContent = styled.div`
  width: 100%;
  max-width: 745px;
  min-height: 280px;
  background-color: white;
  border-radius: 10px;
  padding: 41px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;

  @media screen and (max-width: 900px) {
    padding: 28px 20px;
    min-height: 240px;
    border-radius: 12px;
  }

  @media screen and (max-width: 500px) {
    padding: 20px 16px;
    min-height: 200px;
  }
`

const ModalInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`

const ModalTitle = styled.h3`
  font-weight: 700;
  font-size: 1.875rem;
  line-height: 2.4375rem;
  margin: 0;

  @media screen and (max-width: 500px) {
    font-size: 1.25rem;
    line-height: 1.625rem;
  }
`

const ModalDescription = styled.p`
  font-weight: 400;
  font-size: 1.5625rem;
  line-height: 2rem;
  margin-top: 1rem;

  @media screen and (max-width: 500px) {
    font-size: 1rem;
    line-height: 1.375rem;
  }
`

const ModalActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
  flex-wrap: wrap;

  @media screen and (max-width: 500px) {
    gap: 12px;
    width: 100%;
  }
`

export const Styled = { ModalDescription, ModalTitle, ModalInfo, ModalWrapper, ModalContent, ModalActions }